export const toESTDateString = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  // Convert to EST (UTC-5)
  const estDate = new Date(date.getTime() + (5 * 60 * 60 * 1000));
  return estDate.toISOString().split('T')[0];
};

export const formatDateForDisplay = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  // Convert to EST (UTC-5)
  const estDate = new Date(date.getTime() + (5 * 60 * 60 * 1000));
  return estDate.toLocaleDateString('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};

// Format a date value for table display as MM/DD/YYYY. Date-only strings
// (yyyy-MM-dd, the backend's usual shape) are formatted without going through
// Date, so no timezone can shift them by a day. Datetimes fall back to the
// EST display conversion above.
export const formatDate = (value) => {
  if (!value) return '';
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T)/);
  if (m && s.length === 10) return `${m[2]}/${m[3]}/${m[1]}`;
  return formatDateForDisplay(s);
};

// Normalize a backend date or datetime into the yyyy-MM-dd shape date inputs
// expect. String slicing (not a Date round-trip) so date-only values can never
// shift by a day in other timezones.
export const toDateInputValue = (value) => {
  if (!value) return '';
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().split('T')[0];
};
